import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './GlobalStyle';
import { lightTheme, darkTheme } from './theme';
import { useLocalStorage } from './hooks/useLocalStorage';

// Auth & Layout
import Login from './components/auth/Login';
import SignUp from './components/auth/SignUp';
import PrivateRoute from './components/auth/PrivateRoute';
import MainLayout from './components/layout/MainLayout';

// Pages
import AdminDashboard from './components/pages/AdminDashboard';
import DataEntryDashboard from './components/pages/DataEntryDashboard';
import ClientDashboard from './components/pages/ClientDashboard';
import DocumentUpload from './components/pages/DocumentUpload';
import ClientDocumentView from './components/pages/ClientDocumentView';
import Settings from './components/pages/Settings';
import ManageUsersPage from './components/pages/ManageUsersPage'; // <-- Import the new page
import AddUserPage from './components/pages/AddUserPage'; // <-- Import the new page


function App() {
  const [theme, setTheme] = useLocalStorage('theme', 'dark');

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const currentTheme = theme === 'light' ? lightTheme : darkTheme;

  return (
    <ThemeProvider theme={currentTheme}>
      <GlobalStyle />
      <Router>
        <Toaster position="top-center" reverseOrder={false} />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />

          {/* --- CLIENT ROUTES --- */}
          <Route path="/client/*" element={
              <PrivateRoute roles={['client']}>
                <MainLayout userRole="client" toggleTheme={toggleTheme} currentTheme={theme}>
                  <Routes>
                    <Route path="dashboard" element={<ClientDashboard />} />
                    <Route path="upload" element={<DocumentUpload />} />
                    <Route path="documents" element={<ClientDocumentView />} />
                    <Route path="settings" element={<Settings />} />
                    <Route index element={<Navigate to="dashboard" />} />
                  </Routes>
                </MainLayout>
              </PrivateRoute>
            }
          />
          
          {/* --- DATA ENTRY ROUTES --- */}
          <Route path="/data-entry/*" element={
              <PrivateRoute roles={['data-entry']}>
                <MainLayout userRole="data-entry" toggleTheme={toggleTheme} currentTheme={theme}>
                   <Routes>
                    <Route path="dashboard" element={<DataEntryDashboard />} />
                    <Route path="uploads" element={<DataEntryDashboard />} />
                    <Route index element={<Navigate to="dashboard" />} />
                  </Routes>
                </MainLayout>
              </PrivateRoute>
            }
          />
          
          {/* --- ADMIN ROUTES (NOW WITH NESTED ROUTES) --- */}
<Route path="/admin/*" element={
    <PrivateRoute roles={['admin']}>
      <MainLayout userRole="admin" toggleTheme={toggleTheme} currentTheme={theme}>
        <Routes>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<ManageUsersPage />} />
          <Route path="add-user" element={<AddUserPage />} /> {/* <-- ADD THIS ROUTE */}
          <Route path="settings" element={<AdminDashboard />} />
          <Route index element={<Navigate to="dashboard" />} />
        </Routes>
      </MainLayout>
    </PrivateRoute>
  }
/>

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;